(function(){
  if(typeof Swiper === 'undefined'){
    console.error('Swiper未加载，请检查swiper-bundle.min.js是否引入');
    return;
  }
  if(typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined'){
    console.error('GSAP ScrollTrigger未加载');
    return;
  }
  gsap.registerPlugin(ScrollTrigger);
  const state = {
    activeUptitleIndex: 0,
    activeDowntitleId: "section1",
    swiperInstances: []
  }
  const uptitleList = document.querySelectorAll(".uptitle_f");
  const downboxList = document.querySelectorAll(".downtitle > .downbox");
  const downtitleList = document.querySelectorAll(".downtitle_f");
  const sectionList = document.querySelectorAll(".productbox > .section");
  // section映射到一级tab索引
  const sectionToUptitleMap = {
    "section1":0,
    "section2":0,
    "section3":0,
    "section4":0,
    "section5":0,
    "section6":1
  };
  // 初始化全部Swiper
  function initAllSwiper(){
    const swiperEls = document.querySelectorAll(".box-swiper");
    swiperEls.forEach(el=>{
      try{
        const paginationEl = el.parentElement.querySelector(".swiper-pagination");
        const sw = new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          width: null,
          autoplay: {
            delay: 2200,
            disableOnInteraction: false
          },
          pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet: function (index, className) {
              const slideDom = this.slides[index];
              const bulletColor = slideDom.dataset.bulletColor || "#999";
              return `<span class="${className}" style="background-color:${bulletColor};"></span>`;
            }
          },
          allowTouchMove: true
        });
        sw.updateSize();
        sw.on('tap', function(){
          const url = sw.el.dataset.link;
          if(url){ window.location.href = url; }
        });
        state.swiperInstances.push(sw);
      }catch(e){
        console.error('Swiper初始化失败:', e);
      }
    })
  }
  // 更新tab激活样式
  function setActiveTabState(){
    uptitleList.forEach(el=>el.classList.remove("active"));
    if(uptitleList[state.activeUptitleIndex]){
      uptitleList[state.activeUptitleIndex].classList.add("active");
    }
    downboxList.forEach((box,idx)=>{
      box.style.display = idx === state.activeUptitleIndex ? "flex":"none";
    });
    downtitleList.forEach(tab=>{
      tab.classList.toggle("active", tab.dataset.sectionid === state.activeDowntitleId);
    });
  }
  /**
   * JS平滑滚动，section顶部对齐视口40%位置，弃用hash
   */
  function scrollToSection(sectionId){
    const targetSec = document.getElementById(sectionId);
    if(!targetSec) return;
    const viewportOffset = window.innerHeight * 0.4;
    const scrollY = targetSec.offsetTop - viewportOffset;
    window.scrollTo({
      top: scrollY,
      behavior: "smooth"
    });
  }
  // 一级tab点击
  uptitleList.forEach((item, idx)=>{
    item.addEventListener("click", ()=>{
      state.activeUptitleIndex = idx;
      const targetBox = downboxList[idx];
      const firstTab = targetBox.querySelector(".downtitle_f");
      if(firstTab){
        state.activeDowntitleId = firstTab.dataset.sectionid;
        scrollToSection(state.activeDowntitleId);
      }
      setActiveTabState();
    })
  })
  // 二级tab点击
  downtitleList.forEach(tab=>{
    tab.addEventListener("click", ()=>{
      const sid = tab.dataset.sectionid;
      state.activeDowntitleId = sid;
      state.activeUptitleIndex = sectionToUptitleMap[sid];
      setActiveTabState();
      scrollToSection(sid);
    })
  })

  // ----------------重点改动：把section的ScrollTrigger延迟到DOMContentLoaded之后再创建，不要IIFE立即执行----------------
  let sectionTriggers = [];
  function initSectionScrollTrigger(){
    sectionList.forEach(sec=>{
      const sid = sec.id;
      const st = ScrollTrigger.create({
        trigger: sec,
        start:"top 40%",
        end:"bottom 40%",
        onEnter:()=>{
          state.activeDowntitleId = sid;
          state.activeUptitleIndex = sectionToUptitleMap[sid];
          setActiveTabState();
        },
        onEnterBack:()=>{
          state.activeDowntitleId = sid;
          state.activeUptitleIndex = sectionToUptitleMap[sid];
          setActiveTabState();
        }
      })
      sectionTriggers.push(st);
    })
  }

  initAllSwiper();
  setActiveTabState();

  // 把section触发器初始化暴露出去，不在IIFE内部直接执行
  window.__initSectionScrollTrigger = initSectionScrollTrigger;
})();

document.addEventListener("DOMContentLoaded", function () {
    const navWrap = document.querySelector(".page-products .nav");
    const navLeft = document.querySelector(".page-products .nav_main_left");
    const navRight = document.querySelector(".page-products .nav_main_right");
    if(!navWrap || !navLeft || !navRight || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    // PC常态
    const normalStatePc = {
        position: "relative",
        top: "auto",
        left: "auto",
        xPercent: 0,
        width: "100%",
        borderRadius: "0px",
        background: "#ffffff",
        boxShadow: "inset 0 -4px 12px rgba(0,0,0,0.12)",
        zIndex: 20,
        maskImage: "",
        padding: "2rem 10%",
        WebkitMaskImage: ""
    };
    // PC吸顶胶囊
    const scrollActiveStatePc = {
        position: "fixed",
        top: '3.5rem',
        left: "50%",
        xPercent: -50,
        width: "90rem",
        borderRadius: "2rem",
        background: "rgba(240, 245, 254, 0.5)",
        backdropFilter: "blur(10px)",
        boxShadow: "inset 0 -4px 12px rgba(0,0,0,0.12)",
        zIndex: 20,
        padding: "1.5rem 10%",
        force3D: true
    };
    // 移动端常态
    const normalStateMb = {
        position: "relative",
        top: "auto",
        left: "auto",
        xPercent: 0,
        width: "100%",
        borderRadius: "0px",
        background: "#ffffff",
        boxShadow: "inset 0 -4px 12px rgba(0,0,0,0.12)",
        zIndex: 20,
        maskImage: "",
        padding: "0.5rem 5%",
        WebkitMaskImage: ""
    };
    // 移动端吸顶
    const scrollActiveStateMb = {
        position: "fixed",
        top: '6rem',
        left: "0",
        xPercent: 0,
        width: "100%",
        borderRadius: "0px",
        background: "#fff",
        zIndex: 20,
        padding: "0.5rem 5%",
        force3D: true
    };
    let navScrollTrigger;

    function createNavTrigger(){
        if(navScrollTrigger) navScrollTrigger.kill();
        const isMobile = window.innerWidth <= 750;
        const normal = isMobile ? normalStateMb : normalStatePc;
        const active = isMobile ? scrollActiveStateMb : scrollActiveStatePc;

        gsap.set(navWrap, normal);
        gsap.set(navLeft, {opacity:1, display:"flex"});
        navRight.classList.remove("active");

        navScrollTrigger = ScrollTrigger.create({
            trigger: ".page-products .nav",
            start: "top top",
            end: "9999px bottom",
            invalidateOnRefresh: true,
            markers: false,
            preventOverlaps:true,
            onEnter: () => {
                gsap.killTweensOf([navWrap, navLeft]);
                gsap.to(navWrap, {
                    ...active
                });
                navRight.classList.add("active");
                gsap.to(navLeft, {
                    opacity:0,
                    duration:0.25,
                    onComplete(){
                        navLeft.style.display = "none";
                    }
                });
            },
            onLeaveBack: () => {
                gsap.killTweensOf([navWrap, navLeft]);
                gsap.to(navWrap, {
                    ...normal
                });
                navRight.classList.remove("active");
                gsap.set(navLeft, {display:"flex"});
                gsap.to(navLeft, {
                    opacity:1,
                    duration:0.25
                });
            }
        })
        navScrollTrigger.refresh();
    }

    // hash场景：等待浏览器完成锚点滚动，再同时初始化nav触发器 + section触发器
    function safeInitAllTrigger(){
        const delay = window.location.hash ? 120 : 0;
        setTimeout(()=>{
            createNavTrigger();
            if(window.__initSectionScrollTrigger){
                window.__initSectionScrollTrigger();
            }
        },delay);
    }
    safeInitAllTrigger();

    window.addEventListener('resize', ()=>{
        if(navScrollTrigger) navScrollTrigger.kill();
        createNavTrigger();
    })
});
